import React from "react";
import { ClearedStyleHref } from "@modules/Components";
import styled from "@emotion/styled";

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 1150px) {
    grid-template-columns: 1.5fr 1fr;
  }
  @media (max-width: 767px) {
    grid-template-columns: 2fr 1fr;
    height: 640px;
  }
  @media (max-width: 530px) {
    display: block;
    height: 648px;
    border-radius: 0px 0px 0px 150px;
    background-size: 188% auto;
    background-position-x: -29px;
    background-position-y: -37px;
    background-repeat: no-repeat;
    background-image: ${props => `url("${props.backgroundImage}")`};
  }
  @media (max-width: 480px) {
    background-size: 215% auto;
    background-position-x: -84px;
    background-position-y: -25px;
  }
  @media (max-width: 350px) {
    background-size: 229% auto;
    background-position-x: -95px;
    background-position-y: -3px;
    border-radius: 0px 0px 0px 100px;
  }
  @media (max-width: 325px) {
    background-size: 262% auto;
    background-position-x: -140px;
  }
`;

const Text = styled.div`
  border-radius: 0px 0px 540px 0px;
  height: 100%;
  padding-left: 29%;

  @media (max-width: 1800px) {
    border-radius: 0px 0px 510px 0px;
  }
  @media (max-width: 1700px) {
    padding-left: 24%;
    border-radius: 0px 0px 472px 0px;
  }
  @media (max-width: 1600px) {
    padding-left: 19%;
    border-radius: 0px 0px 447px 0px;
  }
  @media (max-width: 1500px) {
    border-radius: 0px 0px 419px 0px;
  }
  @media (max-width: 1400px) {
    border-radius: 0px 0px 392px 0px;
  }
  @media (max-width: 1300px) {
    border-radius: 0px 0px 361px 0px;
  }
  @media (max-width: 1250px) {
    padding-left: 14%;
  }
  @media (max-width: 1200px) {
    border-radius: 0px 0px 335px 0px;
  }
  @media (max-width: 1150px) {
    padding-left: 0;
    text-align: center;
    height: 570px;
  }
  @media (max-width: 767px) {
    border-radius: 0px 0px 250px 0px;
    height: 100%;
  }
  @media (max-width: 630px) {
    border-radius: 0px 0px 167px 0px;
  }
  @media (max-width: 530px) {
    background-color: rgba(31, 32, 33, 0.4);
    background-blend-mode: color;
    background-image: linear-gradient(
      to bottom,
      rgba(66, 79, 86, 0.05),
      rgba(66, 79, 86, 0.05)
    );
    border-radius: 0px 0px 0px 150px;
  }
  @media (max-width: 350px) {
    border-radius: 0px 0px 0px 100px;
  }
`;

const HeaderText = styled.h1`
  line-height: 1.14;

  color: #1f2021;
`;

const SavingSpan = styled.span`
  @media (max-width: 530px) {
    color: #ffffff;
  }
`;

const HeaderP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  margin: 0% 1% 10% 0%;
  width: 494px;

  @media (max-width: 1800px) {
    font-size: 17px;
    width: 468px;
  }
  @media (max-width: 1400px) {
    font-size: 16px;
    width: 439px;
    margin: 0% 1% 9% 0%;
  }
  @media (max-width: 1150px) {
    margin: 0 auto;
    width: 352px;
    margin-bottom: 30px;
  }
  @media (max-width: 767px) {
    font-size: 18px;
  }
  @media (max-width: 530px) {
    color: #ffffff;
    width: 337px;
    margin-bottom: 58px;
  }
  @media (max-width: 350px) {
    width: 291px;
    font-size: 17px;
  }
`;

const Href = styled(ClearedStyleHref)`
  width: 226px;
  height: 72px;
  border-radius: 36px;

  font-size: 16px;
  font-weight: bold;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1150px) {
    margin: 0 auto;
  }
`;

const MobileImage = styled.img`
  display: none;
`;

const BulkHeader = ({
  headerOne,
  headerTwo,
  text,
  image,
  classFromParent,
  buttonText,
  mobileImage,
  noPeriod,
  onButtonClick,
  hideButton
}) => {
  return (
    <Header backgroundImage={image} className={classFromParent}>
      <Text className="bulk-text-main">
        <HeaderText className="double-header-header-text">
          {headerOne}{" "}
          <SavingSpan className="bulk-saving-span">{headerTwo}</SavingSpan>
          {!noPeriod && <span>.</span>}
        </HeaderText>
        <HeaderP className="bulk-header-p">{text}</HeaderP>
        {!hideButton && (
          <Href
            onClick={onButtonClick}
            className={
              "button-transition-hover-bgColor-color bulk-header-button"
            }
            type="button"
            as={"button"}
          >
            {buttonText}
          </Href>
        )}
      </Text>
      <div className="header-image-container">
        <img src={image} alt="" className="bulk-header-image" />
        {mobileImage && (
          <MobileImage
            src={mobileImage}
            alt=""
            className="bulk-header-mobile-image"
          />
        )}
      </div>
    </Header>
  );
};

export default BulkHeader;
